export default "/images/ai_service__upper.png";